export class DataCleanerSearch {
  public id: string;
  public corporationId: string;
  public entity: string;
  public dataCenter: string;
  public cluster: string;
  public searchName: string;
  public searchType = 'datacleaner';
  public searchStatus: SearchStatus;
  public requestingUserId = '';
  public results = '';
  public errorMessage: string;
  public scheduledTime: Date;
  public queuedTime: Date;
  public completedTime: Date;
  public ttl: number;
  public searchProperties: SearchProperties;
  public postSearchActions: PostSearchAction[];
  public activityFilters: ActivityFilter[];
}

export interface IGroupedSearches {
  COMPLETED: DataCleanerSearch[];
  RUNNING: DataCleanerSearch[];
  QUEUED: DataCleanerSearch[];
  SCHEDULED: DataCleanerSearch[];
  FAILED: DataCleanerSearch[];
}

export enum SearchStatus {
  SEARCH_SCHEDULED = 'SCHEDULED',
  SEARCH_QUEUED = 'QUEUED',
  SEARCH_RUNNING = 'RUNNING',
  SEARCH_COMPLETED = 'COMPLETED',
  SEARCH_FAILED = 'FAILED',
  SEARCH_DELETED = 'DELETED'
}

class PostSearchAction {
  public type: String;
  public details = {};
}

class ActivityFilter {
  entityType: String;  // main entity association
  entityField = 'dateAdded';
  activityType: String;
  activitySubType: String;
  dateOperator: String;  // within,before
  dateValue: String;
  hasActivity: Boolean; 
}

export class SearchProperties {
  constructor(
    public email: boolean = false,
    public email2: boolean = false,
    public email3: boolean = false,
    public skills: boolean = false,
    public phone: boolean = false,
    public phone2: boolean = false,
    public phone3: boolean = false,
    public workPhone: boolean = false,
    public mobile: boolean = false,
    public comments: boolean = false,
    public notes: boolean = false,
    public linkedPerson: boolean = false,
    public hasFileAttachment: boolean = false,
    public noFileAttachment: boolean = false,
    public placements: boolean = false,
    public sendouts: boolean = false,
    public interviews: boolean = false,
    public submissions: boolean = false,
    public dateLastComment: Date | number = null,
    public dateAddedBefore: number | null = null,
    public dateAddedWithin: string | number= '',
    public includeNoteTypes: string[] = [],
    public excludeNoteTypes: string[] = [],
    public customSearchQueryTerm: string = '',
    public country: boolean = false,
    public zip: boolean = false,
    public city: boolean = false,
    public futureTasks: boolean = false,
    public futureAppointments: boolean = false,
    public candidate: boolean = true
  ) {}
}
